import React from 'react';
import { AuthProvider } from './context/auth';
import Routes from './routes/Routes';
import { locale, addLocale } from 'primereact/api';

function App() {
    addLocale('pt', {
        "accept": "Sim",
        "reject": "Não",
        "choose": "Escolha",
        "upload": "Upload",
        "cancel": "Cancelar",
        "dayNames": ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
        "dayNamesShort": ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
        "dayNamesMin": ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
        "monthNames": ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        "monthNamesShort": ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        "today": "Hoje",
        "clear": "Limpar",
        "weekHeader": "Sem",
        "firstDayOfWeek": 0,
        "dateFormat": "dd/mm/yy",
        "weak": "Fraco",
        "medium": "Médio",
        "strong": "Forte",
        "passwordPrompt": "Digite uma senha"
    })
    locale('pt');

    return (
        <AuthProvider>
            <Routes />
        </AuthProvider>
    )
}

export default App;
